import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
;(function () {
  const HERO_SELECTOR = '.hero-slider.swiper'
  const heroEl = document.querySelector(HERO_SELECTOR)

  if (!heroEl) {
    return
  }

  // create or reuse Swiper instance
  let heroSwiper = window.heroSwiper || heroEl.swiper || null
  if (!heroSwiper) {
    heroSwiper = new Swiper(HERO_SELECTOR, {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      loop: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      speed: 1000,
      grabCursor: true,
      pagination: { el: '.swiper-pagination-hero', type: 'progressbar' }
    })
    window.heroSwiper = heroSwiper
  }

  ;(function attachSegments(swiperInstance) {

    const AUTOPLAY_DELAY =
      (swiperInstance.params &&
        swiperInstance.params.autoplay &&
        swiperInstance.params.autoplay.delay) ||
      4000
    let prevSegIdx = -1

    function buildSegmentsUI() {
      const existing = swiperInstance.el.querySelector('.autoplay-segments')
      if (existing) {
        existing.remove()
      }

      const realSlides = Array.from(
        swiperInstance.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
      )
      const count =
        realSlides.length ||
        Math.max(
          1,
          (swiperInstance.slides && swiperInstance.slides.length) -
            (swiperInstance.params && swiperInstance.params.loop ? 2 : 0)
        )

      const container = document.createElement('div')
      container.className = 'autoplay-segments'

      for (let i = 0; i < count; i++) {
        const track = document.createElement('div')
        track.className = 'seg-track'
        const fill = document.createElement('div')
        fill.className = 'seg-fill'
        fill.style.transition = `width ${AUTOPLAY_DELAY}ms linear`
        fill.style.width = '0%'
        track.appendChild(fill)
        container.appendChild(track)
      }

      swiperInstance.el.appendChild(container)
    }

    function getFills() {
      return Array.from(swiperInstance.el.querySelectorAll('.autoplay-segments .seg-fill'))
    }

    function setStaticWidths(idx) {
      const fills = getFills()
      fills.forEach((f, i) => {
        f.style.transition = 'none'
        if (i < idx) {
          f.style.width = '100%'
        } else {
          f.style.width = '0%'
        }
      })
      // force reflow then restore inline transition so current fill will animate
      void document.body.offsetHeight
      fills.forEach((f) => {
        f.style.transition = `width ${AUTOPLAY_DELAY}ms linear`
      })
    }

    function animateSegmentAtIdx(idx) {
      const fills = getFills()
      if (!fills.length) {
        return
      }
      const clamped = Math.max(0, Math.min(idx, fills.length - 1))

      fills.forEach((f, i) => {
        f.style.transition = 'none'
        if (i < clamped) {
          f.style.width = '100%'
        } else {
          f.style.width = '0%'
        }
      })

      void document.body.offsetHeight

      const cur = fills[clamped]
      if (!cur) {
        return
      }
      cur.style.transition = `width ${AUTOPLAY_DELAY}ms linear`
      requestAnimationFrame(() => {
        cur.style.width = '100%'
      })

      prevSegIdx = clamped
    }

    function canonicalIndex() {
      if (typeof swiperInstance.realIndex === 'number') {
        return swiperInstance.realIndex
      }
      const a = swiperInstance.el.querySelector('.swiper-slide-active')
      if (a) {
        const v = a.getAttribute('data-swiper-slide-index')
        if (v !== null) {
          return Number(v)
        }
      }
      return swiperInstance.activeIndex || 0
    }

    function onSlideChange() {
      const idx = canonicalIndex()
      setStaticWidths(idx)
      setTimeout(() => {
        animateSegmentAtIdx(idx)
      }, 10)
    }

    function handleAutoplayTimeLeft(s, time, progress) {
      const fills = getFills()
      if (!fills.length) {
        return
      }
      const idx = typeof s.realIndex === 'number' ? s.realIndex : canonicalIndex()
      const elapsed =
        typeof progress === 'number'
          ? Math.max(0, Math.min(1, 1 - progress))
          : time
            ? Math.max(0, Math.min(1, 1 - time / AUTOPLAY_DELAY))
            : 0
      fills.forEach((f, i) => {
        f.style.transition = 'none'
        if (i < idx) {
          f.style.width = '100%'
        } else if (i === idx) {
          f.style.width = elapsed * 100 + '%'
        } else {
          f.style.width = '0%'
        }
      })
      void document.body.offsetHeight
      fills.forEach((f) => {
        f.style.transition = `width ${AUTOPLAY_DELAY}ms linear`
      })
    }

    // initialize
    buildSegmentsUI()
    setTimeout(() => {
      onSlideChange()
    }, 16)

    if (swiperInstance.on) {
      swiperInstance.on('slideChange', () => {
        setTimeout(() => {
          onSlideChange()
        }, 10)
      })

      try {
        swiperInstance.on('autoplayTimeLeft', handleAutoplayTimeLeft)
      } catch (e) {
        // if event not supported, ignore silently
      }

      swiperInstance.on('slidesLengthChange', () => {
        buildSegmentsUI()
        setTimeout(() => {
          onSlideChange()
        }, 10)
      })
    }
  })(heroSwiper)
})()
